export class ItemCalculator {
    constructor(strategy) {
        this.strategy = strategy;
    }

    calculate(item) {
        return this.strategy.calculate(item);
    }
}